module.exports = __webpack_public_path__ + "img/logo-perindo-new.853a254e.png";